import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({providedIn:'root'})
export class AdminService {
  apiServer = environment.apiHost + environment.apiPort;
constructor(private http : HttpClient) {

 }

 syncGuestImportance(subscriber: string, hotelId: number) {
  return this.http.get(this.apiServer + '/api/kip/admin/SyncGuestImportance/' + subscriber + "/" + hotelId);  
 }

 syncMinibarItems(subscriber: string, hotelId: number) {
  return this.http.get(this.apiServer + '/api/kip/admin/syncMinibarItems/' + subscriber + "/" + hotelId);
 }

 syncEquipments(subscriber: string, hotelId: number) {
  return this.http.get(this.apiServer + '/api/kip/admin/SyncEquipments/' + subscriber + "/" + hotelId);
 }
}
